module.exports = __webpack_public_path__ + "static/media/shoot.57e1d669.png";